<template>
    <div class="p-1">
        <div class="row">
            <div class="col-md-auto">
                <v-picture-cropper placeholder="Personel Fotoğrafı" :picture="value.File" v-on:change="value.File = $event"></v-picture-cropper>
            </div>
            <div class="col-md">
                <div class="row">
                    <div class="col-12 mb-1">
                        <b-form-checkbox v-model="value.IsTcCitizen">TC Vatandaşı</b-form-checkbox>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Kimlik Numarası</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.IdentityNumber" :watch="value.IdentityNumber">
                            <input type="text" v-mask="value.IsTcCitizen ? $mask.TCKN : null" class="form-control" v-model="value.IdentityNumber" placeholder="Kimlik Numarası"/> 
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Adı</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.FirstName" :watch="value.FirstName">
                            <input type="text" class="form-control" v-model="value.FirstName" placeholder="Adı"/> 
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Soyadı</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.LastName" :watch="value.LastName">
                            <input type="text" class="form-control" v-model="value.LastName" placeholder="Soyadı"/> 
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Doğduğu Ülke</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.BirthCountryId" :watch="value.BirthCountryId">
                            <v-select-list v-model="country" v-on:input="getProvinces(true)" placeholder="Doğduğu Ülke" label="Name" :options="countries"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Doğduğu Şehir</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.BirthProvinceId" :watch="value.BirthProvinceId">
                            <v-select-list :disabled="!value.BirthCountryId" v-model="province" placeholder="Doğduğu Şehir" label="Name" :options="provinces"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <div class="row">
                            <div :class="age > 0 ? 'col-lg-9 col-md-8' : 'col-12'">
                                <label class="form-label">Doğum Tarihi</label>
                                <v-validator :errors="errors" parameter="EmployeeInformation.BirthDate" :watch="value.BirthDate">
                                    <v-date-picker v-model="value.BirthDate" placeholder="Doğum Tarihi"></v-date-picker>
                                </v-validator>
                            </div>
                            <div class="col-lg-3 col-md-4" v-if="age > 0">
                                <label class="form-label">Yaş</label>
                                <input class="form-control text-center" type="text" disabled :value="age"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Cinsiyet</label>
                        <b-form-radio-group id="gender-group" v-model="value.Gender" :options="genders"></b-form-radio-group>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Kimlik Seri Numarası</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.IdentityDocumentSerialNumber" :watch="value.IdentityDocumentSerialNumber">
                            <input type="text" class="form-control" placeholder="Kimlik Seri Numarası" v-model="value.IdentityDocumentSerialNumber"/> 
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Anne Adı</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.NameOfMother" :watch="value.NameOfMother">
                            <input type="text" class="form-control" placeholder="Anne Adı" v-model="value.NameOfMother"/> 
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Baba Adı</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.NameOfFather" :watch="value.NameOfFather">
                            <input type="text" class="form-control" placeholder="Baba Adı" v-model="value.NameOfFather"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Medeni Durumu</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.MaritialStatusId" :watch="value.MaritialStatusId">
                            <v-select-list v-model="maritialStatus" placeholder="Medeni Durumu" label="Name" :options="maritialStatuses"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Evlilik Tarihi</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.DateOfMarriage" :watch="value.DateOfMarriage">
                            <v-date-picker :disabled="maritialStatus && !$safe(maritialStatus,'DateRequired')" v-model="value.DateOfMarriage" placeholder="Evlilik Tarihi"></v-date-picker>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Kan Grubu</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.BloodGroupId" :watch="value.BloodGroupId">
                            <v-select-list v-model="blood" placeholder="Kan Grubu" label="Name" :options="bloods"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Çalışma Grubu</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.WorkingGroupId" :watch="value.WorkingGroupId">
                            <v-select-list v-model="workingGroup" placeholder="Çalışma Grubu" label="Name" :options="workingGroups"/>
                        </v-validator>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <label class="form-label">Engellilik Oranı</label>
                        <div class="row align-items-end">
                            <div class="col-auto">
                                <b-form-checkbox class="mb-50" v-model="value.DisabledPerson">Engelli</b-form-checkbox>
                            </div>
                            <div class="col">
                                <input class="form-control" type="number" :disabled="!value.DisabledPerson" v-model="value.DisabilityRate" v-on:input="controlDisabledRate"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Ek Bilgiler</label>
                        <v-validator :errors="errors" parameter="EmployeeInformation.AdditionalInformation" :watch="value.AdditionalInformation">
                            <textarea class="form-control resize-none" placeholder="Ek Bilgiler" v-model="value.AdditionalInformation"></textarea>
                        </v-validator>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column align-items-end">
            <b-form-checkbox class="mb-50" v-model="value.PartTime">Kısmi İstihdam</b-form-checkbox>
            <v-executer :loading="loading" text="Özlük Bilgilerini Kaydet" :action="save"></v-executer>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox,BFormRadioGroup,BFormSpinbutton } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/l10n/tr.js' 
import SystemDataApi from '@/api/system-data'
import EmployeeOperationsApi from '@/api/employee-operations' 
import OperationalParametersApi from '@/api/operational-parameters'
import VPictureCropper from '@/components/VPictureCropper.vue'
import Additional from '@/utilities/additional'
import moment from 'moment'

export default {
    components:{
        BFormCheckbox,
        BFormRadioGroup,
        flatPickr,
        VPictureCropper,
        BFormSpinbutton
    },
    props:{
        value:Object,
        editing:Boolean,
        getPersonal:Function,
        employeeLoaded:Boolean,
        candidate:Boolean
    },
    watch:{
        "value.DisabledPerson"(newV,oldV){
            if(oldV && !newV){
                this.value.DisabilityRate = 0
            }
        },
        "maritialStatus"(newV,oldV){
            if(oldV?.DateRequired && !newV.DateRequired){
                this.value.DateOfMarriage = null
            }
        },
        employeeLoaded(val){
            if(val) this.getCountries()
        }
    },
    data(){
        return{
            countries:[],
            provinces:[],
            bloods:[],
            loading:false,
            maritialStatuses:[],
            workingGroups:[],
            errors:{},
            genders:[
                {text:"Erkek",value:true},
                {text:"Kadın",value:false},
                {text:"Belirtilmemiş",value:null}
            ]
        }
    },
    mounted(){
        this.getCountries()
        this.getProvinces()
        this.getBloods()
        this.getMaritialStatuses()
        this.getWorkingGroups()
    },
    methods:{
        getCountries(){
            if((this.countries || []).length == 0){
                SystemDataApi.Country().then(res=>{
                    this.countries = res.data.Data
                    if(this.value.BirthCountryId == null){
                        this.value.BirthCountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                    }
                    this.getProvinces()
                })
            }else {
                if(this.value.BirthCountryId == null){
                    this.value.BirthCountryId = this.countries?.find(c=>c.IsDefault)?.Id  || null
                }
                this.getProvinces()
            }
        },
        getProvinces(bool){
            if(bool) this.value.BirthProvinceId = null
            if(this.value.BirthCountryId){
                SystemDataApi.ProvinceByCountry(this.value.BirthCountryId).then(response=>{
                    this.provinces = response.data.Data
                })
            }
        },
        getBloods(){
            SystemDataApi.Blood().then(response=>{
                this.bloods = response.data.Data
            })
        },
        getMaritialStatuses(){
            SystemDataApi.MaritialStatus().then(response=>{
                this.maritialStatuses = response.data.Data
            })
        },
        getWorkingGroups(){
            OperationalParametersApi.WorkingGroup.List().then(response=>{
                this.workingGroups = response.data.Data
            })
        },
        async save(){
            const candidateEmployeeId = this.candidate && ![0, "0"].includes(this.$route.params.id) ? this.$route.params.id : null
            let data = {
                Step:1,
                EmployeeId:this.value.Id,
                CandidateEmployeeId:candidateEmployeeId,
                EmployeeInformation:this.value,
            }
            let formData = await Additional.ToFormData(data,["EmployeeInformation.File"])
            this.loading = true
            const submit = this.candidate ? EmployeeOperationsApi.Employee.Candidate.CreateOrUpdate : EmployeeOperationsApi.Employee.CreateOrUpdate
            submit(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    if(this.value.Id != res.data.Data.Id){
                        const routeName = this.candidate ? 'candidate-employee-create-or-update' : 'employee-create-or-update'
                        this.$router.push({name:routeName,params:{id:res.data.Data.Id}})
                    }
                    this.getPersonal()
                    this.value.RegistrationCode= res.data.Data.RegistrationCode
                    this.value.Id = res.data.Data.Id
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        controlDisabledRate(){
            if(this.value.DisabilityRate > 100){
                this.value.DisabilityRate = 100
            }
            if(this.value.DisabilityRate < 0){
                this.value.DisabilityRate = 0
            }
            this.value.DisabilityRate = parseInt(Number(this.value.DisabilityRate))
        }
    },
    computed:{
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.BirthCountryId)
            },
            set:function(value){
                this.value.BirthCountryId = value?.Id || null
            }
        },
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.BirthProvinceId)
            },
            set:function(value){
                this.value.BirthProvinceId = value?.Id || null
            }
        },
        blood:{
            get:function(){
                return this.bloods.find(b=>b.Id==this.value.BloodGroupId)
            },
            set:function(value){
                this.value.BloodGroupId = value?.Id || null
            }
        },
        maritialStatus:{
            get:function(){
                return this.maritialStatuses.find(b=>b.Id==this.value.MaritialStatusId)
            },
            set:function(value){
                this.value.MaritialStatusId = value?.Id || null
            }
        },
        workingGroup:{
            get:function(){
                return this.workingGroups.find(b=>b.Id==this.value.WorkingGroupId)
            },
            set:function(value){
                this.value.WorkingGroupId = value?.Id || null
            }
        },
        age(){
            var birthDate = moment(this.value.BirthDate);
            var today = moment();
            if(today && birthDate){
                var diffDuration = moment.duration(today.diff(birthDate))
                if(diffDuration){
                    if(diffDuration.years()) return diffDuration.years()
                    else return 0
                }else return 0
            }else return 0
        }
    }
}
</script>

